import { render, staticRenderFns } from "./EditSubCategory.vue?vue&type=template&id=5d3586c4&scoped=true"
import script from "./EditSubCategory.vue?vue&type=script&lang=js"
export * from "./EditSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3586c4",
  null
  
)

export default component.exports